export enum BaseCustomerProviderTabsEnum {
  MaterData,
  EmployeeLease,
  IZS,
}
